import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Events } from 'src/app/shared/models/event.model';
import { HomeService } from '../../services/home.service';
import preloaderData from '../../../../assets/data-json/preloader.json';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Title ,Meta } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { SubscriptionFormComponent } from 'src/app/shared/modals/subscription-form/subscription-form.component';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss']
})
export class EventDetailsComponent implements OnInit {

  public curentEvent:Events
  private eventId: string;
  description: any;
  public preloader: any = preloaderData;
  constructor(
    private homeService:HomeService, 
    private route: ActivatedRoute,
    private modalService: NgbModal, 
    private router: Router,
    private datePipe: DatePipe,
    private metaService: Meta, private title: Title,
    private toastService: ToastService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.eventId = params['id']
        this.homeService.getDescription(params['id']).subscribe(res => {
          this.description = res.Data['description'];
          
        }, error => {
          this.description = ''
        })
        this.homeService.getEventByID(params['id']).subscribe(event => {
          if(event.status == 200){
            this.curentEvent = event.Data[0];
            this.metaService.updateTag( { property: 'og:image', content: this.curentEvent?.imageCover } );
            this.title.setTitle(this.curentEvent.name);
            this.metaService.updateTag( { name: 'twitter:image', content: this.curentEvent?.imageCover } );
            this.metaService.updateTag( { name: 'twitter:image', content: this.curentEvent?.imageCover } );
          } else if(event.status == 404){
            this.router.navigateByUrl('/not');
          } else {
            this.toastService.error()
          }
        }, error => {
          this.router.navigateByUrl('/nott');
        })
      }
    })
  }

  opensubscriptionForm() {
    const modalRef = this.modalService.open(
      SubscriptionFormComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true
    });
    modalRef.componentInstance.eventId = this.eventId;
    modalRef.result.then((result) => {
      if (result && result != "Cross click") {
      }
    });
  }

  convertDate(date){
    const userLang: string = localStorage.getItem('lang');
    
    if(date){
      return moment(date).locale(userLang).format('MMMM Do, YYYY');
    } else{
      return '';
    }
  }

}
